import { useState } from "react";
import PageTitleDescription from "components/PageTitleDescription/PageTitleDescription";
import PatientProgress from "components/PatientProgress/PatientProgress";
import OrderCards from "components/OrderCards/OrderCards";
import { useAccountViewLayoutContext } from "components/Layouts/AccountViewLayout/AccountViewLayout";

const AccountDashboard = () => {
  const { dashboardData, loadingDashboardData } = useAccountViewLayoutContext();
  const [notAccessedTrigger, setNotAccessedTrigger] = useState(0);

  return (
    <div className="h-full flex flex-col gap-4">
      <PageTitleDescription title="Overview" />

      <div className="grow h-0 flex flex-col gap-5 overflow-auto pb-6">
        <OrderCards
          data={dashboardData}
          loading={loadingDashboardData}
          onViewNotAccessed={() => setNotAccessedTrigger((prev) => prev + 1)}
        />
        <PatientProgress applyNotAccessedFilter={notAccessedTrigger} />
      </div>
    </div>
  );
};

export default AccountDashboard;
